export const bim = {
  addBim: "BIM 추가",
  progressHelp:
    "파일을 보려면 처리해야 합니다. 이 과정은 몇 분이 소요될 수 있습니다.",
};
